// @flow
import React from 'react';
import PropTypes from 'prop-types'
import moment from 'moment';
import styled from 'styled-components';
import Icon from '../icon/Icon';
import { ICONS } from '../icon/Icons';
import { formatDateWithPlaceholder } from '../../../../utils/date-utils';

import colors from '../ui/colors';

const propTypes = {
  handlePrev: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  currentMonth: PropTypes.instanceOf(moment).isRequired,
};

const defaultProps = {};

const DateRangeHeader = styled.div`
  width: 100%;
  font-size: 0.75rem;
  color: #417505;
  line-height: 1em;
  display: flex;
  align-items: center;
  padding-bottom: 0.15rem;
  background: #f3f3f3;
`;

const DateStart = styled.div`
  width: 50%;
  position: relative;
  height: 1.75rem;
`;

const DateContentWrap = styled.div`
  //width: calc(100% - 0.5625rem);
  width: calc(100% - 0.4175rem);
  background: white;
  height: 100%;
  position: absolute;
  top: 0;
  padding: 0 0.5rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${props => props.start && `
    left: 0;
  `}

  ${props => props.end && `
    right: 0;
  `}

  svg {
    fill: #417505;
    width: 1.25rem;
    height: 1.25rem;
    flex-shrink: 0;
    flex-grow: 0;
    margin-right: 0.5rem;
  }
`;

const DateEnd = styled.div`
  width: 50%;
  position: relative;
  height: 1.75rem;
`;

const ArrowBgEnd = styled.div`
  width: 0.5625rem;
  height: 1.75rem;
  position: absolute;
  top: 0;
  right: -0.125rem;
  svg {
    fill: white;
    width: inherit;
    height: inherit;
  }
`;

const ArrowBgStart = styled.div`
  width: 0.5625rem;
  height: 1.75rem;
  position: absolute;
  top: 0;
  left: -0.125rem;
  svg {
    fill: white;
    width: inherit;
    height: inherit;
  }
`;

const StyledTitleBlock = styled.div`
  background: #f4f4f4;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  height: 2.875rem;
  color: ${colors.BRAND_GREEN};
  text-transform: capitalize;
`;

const StyledTitle = styled.span`
  flex: 1;
  text-align: center;
  font-size: 0.9375rem;
  color: ${colors.GRAY_DARK};
`;

const StyledWeekDaysHeader = styled.ul`
  background: white;
  list-style: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
  line-height: 2rem;
  text-transform: uppercase;
  padding: 1.25rem 1.25rem 0;
  margin: 0;
  font-size: 0.875rem;
  color: ${colors.GRAY_DARK};
  li {
    flex: 1 0;
    text-align: center;
  }
`;

const StyledButton = styled.button`
  background: transparent;
  padding: 0 .5rem;
  line-height: 0;
  color: #424242;
  svg {
    width: 0.625rem;
    height: 0.625rem;
  }

  &[disabled] {
    svg {
      opacity: .5;
    }
  }
`;

const Header = (props:Object) => {
  const thisMonth = moment();
  const prevDisabled = props.currentMonth.clone().subtract(1, 'month').isBefore(thisMonth, 'month');
  const weekDays = moment.weekdaysShort(true);

  return (
    <header>
      {props.showDateRanges && (
        <DateRangeHeader>
          <DateStart>
            <DateContentWrap start>
              <Icon icon={ICONS.CALENDAR_PLUS} />
              {formatDateWithPlaceholder(props.range.start, '...')}
            </DateContentWrap>
            <ArrowBgEnd>
              <Icon icon={ICONS.ARROW_BG_END} />
            </ArrowBgEnd>
          </DateStart>
          <DateEnd>
            <DateContentWrap end>
              {formatDateWithPlaceholder(props.range.end, '...')}
            </DateContentWrap>
            <ArrowBgStart>
              <Icon icon={ICONS.ARROW_BG_START} />
            </ArrowBgStart>
          </DateEnd>
{/*          
          <Icon icon={ICONS.CALENDAR_PLUS} />
          <Dates>{formattedDates}</Dates>*/}
        </DateRangeHeader>
      )}
      <StyledTitleBlock>
        <StyledButton onClick={props.handlePrev} disabled={prevDisabled}>
          <Icon icon={ICONS.ARROW_LEFT} />
        </StyledButton>
        <StyledTitle>{props.currentMonth.format('MMMM YYYY')}</StyledTitle>
        <StyledButton onClick={props.handleNext}>
          <Icon icon={ICONS.ARROW_RIGHT} />
        </StyledButton>
      </StyledTitleBlock>
      <StyledWeekDaysHeader>
        {weekDays.map((day, i) =>
          <li key={i}>{day}</li>
        )}
      </StyledWeekDaysHeader>
    </header>
  );
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;



// WEBPACK FOOTER //
// ./src/modules/common/components/calendar/Header.js